import { render, staticRenderFns } from "./WithdrawOPD.vue?vue&type=template&id=16ef413f&"
import script from "./WithdrawOPD.vue?vue&type=script&lang=js&"
export * from "./WithdrawOPD.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawOPD.vue?vue&type=style&index=0&id=16ef413f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports